<template>
  <!-- 句子排序 -->
  <div v-if="isReady">
    <div class="sentence-order-panel common-panel">
      <div class="panel-content">
        <div class="panel-content-stem">{{ serial ? serial + ". " : "" }}{{ descriptionText }}</div>
        <!-- 填空选项 -->
        <AnswerInputBox
          :textType="'string'"
          :textArr="inputAnswers"
          :center="true"
          :baseStyles="baseStyles"
          @remove="removeInput"
        ></AnswerInputBox>
        <!-- 答案选项 -->
        <div class="panel-content-answer">
          <ul class="answer-list" ref="answers">
            <li
              v-for="(option, index) in jsonData.answers"
              :key="`${currItem.index}${index}`"
              class="answer-item"
              :ref="`refAnswer${option.index}`"
              @click="checkHandler($event, option)"
            >
              <span class="answer-item-order">{{ option.flag }}</span>
              <div class="answer-item-content">
                <PhoneticText
                  :showPinyin="true"
                  :originData="option.content"
                  :baseStyles="{
                    ...baseStyles,
                    hzFontSize: '16px',
                    hzLineHeight: '24px',
                  }"
                ></PhoneticText>
              </div>
            </li>
          </ul>
        </div>
        <!-- 结果提示 -->
        <div class="panel-content-result result-correct" v-if="isCorrect && isShowAnAnalysis && isFinished">
          {{ $t("textbook_chioce_word_text_correct_tip") }}
        </div>
        <div class="panel-content-result result-error" v-if="!isCorrect && isShowAnAnalysis && isFinished">
          <p class="error-tips">
            {{ $t("textbook_chioce_word_text_error_tip") }}
          </p>
          <div class="correct-box">
            <p class="correct-box-title">
              {{ $t("textbook_chioce_word_text_error_title") }}
            </p>
            <div class="correct-box-answer" v-for="(item, index) in correctAnswers" :key="`${currItem.index}${index}`">
              <span class="order" v-show="index > 0">{{ index + 1 }}.</span>
              <span>{{ item }}</span>
            </div>
          </div>
        </div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mixinCommon } from "@/mixins";
import AnswerInputBox from "@/components/answerInputBox/AnswerInputBox.vue";
import PhoneticText from "@/components/ui/phoneticText";

export default {
  name: "CommonSortSentence",
  mixins: [mixinCommon],
  components: {
    AnswerInputBox,
    PhoneticText,
  },
  data() {
    return {
      // 试题数组
      items: [],
      // 当前小题Index
      currIndex: 0,
      // 当前小题项
      currItem: {},
      // 当前小题填空项
      inputAnswers: [],
      // 当前小题是否作答成功
      isCorrect: null,
      correctArray: [],
    };
  },
  computed: {
    // 显示下一题
    isFinished() {
      return this.isReady && !this.inputAnswers.some((item) => item.text === "");
    },
    // 正确答案
    correctAnswers() {
      return this.jsonData.correct_answer.map((item) => item.answer);
    },
    // 填空项显示的状态
    blankType() {
      return "";
    },
    isReady() {
      return !!this.jsonData;
    },
    language() {
      let local = localStorage.getItem("language");
      return local;
    },
    descriptionText() {
      return this.jsonData.question_description_obj
        ? this.jsonData.question_description_obj[this.language]
          ? this.jsonData.question_description_obj[this.language]
          : this.jsonData.question_description_obj["zh"]
        : "";
    },
  },
  watch: {
    isReady: {
      handler(val) {
        if (val) {
          this.setInputAnswers();
        }
      },
      immediate: true,
    },
    isFinished: {
      handler() {
        this.handleSubmit();
      },
    },
    jsonData: {
      handler() {
        this.setInputAnswers();
        // 同一题型清除数据
        console.log(this.$refs.answers.children);
        for (let i = 0; i < this.$refs.answers.children.length; i++) {
          this.$refs.answers.children[i].classList.remove("active");
        }
      },
    },
  },
  methods: {
    // 设置填空选项
    setInputAnswers() {
      this.inputAnswers = this.jsonData.answers.map((item) => {
        return {
          text: "",
          answerIndex: "",
        };
      });
      this.correctArray = this.jsonData.correct_answer.map((item) => {
        return this.splitCorrectAnswers(item.answer);
      });
      console.log(this.correctArray);
    },
    // 点击答题
    checkHandler(event, option) {
      const target = event.currentTarget;
      if (target.classList.contains("active")) {
        // 已选择则取消
        target.classList.remove("active");
        this.inputAnswers = this.inputAnswers.map((item) => {
          if (item.answerIndex === option.id) {
            return {
              ...item,
              text: "",
            };
          } else {
            return {
              ...item,
            };
          }
        });
      } else {
        // 未选择
        const emptyInputIndex = this.inputAnswers.findIndex((item) => item.text === "");
        if (emptyInputIndex == -1) return;
        target.classList.add("active");
        this.inputAnswers.splice(emptyInputIndex, 1, {
          answerIndex: option.id, // 兼容水平测结构
          text: option.flag,
        });
      }
    },
    // 点击填空，取消答案
    removeInput({ inputIndex, answerIndex }) {
      this.$refs[`refAnswer${answerIndex}`][0].classList.remove("active");
      this.inputAnswers.splice(inputIndex, 1, {
        ...this.inputAnswers[inputIndex],
        text: "",
      });
    },
    //将正确答案拆分两两分组
    splitCorrectAnswers(array) {
      let length = this.jsonData.answers.length;
      let answerArray = [];
      this.jsonData.answers.map((item, index) => {
        if (index < length - 1) {
          answerArray.push("");
        }
      });
      answerArray = answerArray.map((element, index) => {
        return array[index] + "," + array[index + 1];
      });
      return answerArray;
    },
    // 提交
    handleSubmit() {
      // 判断答案是否正确
      let correctAnswers = this.jsonData.correct_answer.map((item) => {
        return item.content;
      });
      let array = this.inputAnswers.filter(function (item) {
        return item.text;
      });

      let anserArray = array.map((item) => {
        return item.text;
      });
      let userAnswer = anserArray.join(",");
      this.isCorrect = correctAnswers.includes(userAnswer);
      let userAnswerText = this.inputAnswers.map((item) => item.text).join(",");
      let params = {
        answer: userAnswerText,
        questionId: this.jsonData.index,
        scores: this.isCorrect ? this.jsonData.score : 0,
      };
      this.$emit("customInterface", this.isFinished ? params : "");
    },
    //根据某个text判断下标，提交答案时使用
    searchIndex(text) {
      let indexObj = this.jsonData.answers.find((item) => item.flag === text);
      return indexObj.index;
    },
    //查看最终答案包含几个答案分组节点
    checkNodeNum(nodeArray, answerStr) {
      let num = 0;
      nodeArray.forEach((item) => {
        if (answerStr.indexOf(item) > -1) {
          num++;
        }
      });
      return num;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./common.scss";

.sentence-order-panel {
  .panel-content {
    ::v-deep .answer-input-box {
      width: auto;
    }
    &-answer {
      .answer-list {
        // width: 840px;
        margin: 30px auto;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .answer-item {
          position: relative;
          cursor: pointer;
          width: 410px;
          min-height: 40px;
          margin: 10px;
          padding: 10px 20px;
          border-radius: 5px;
          background-color: rgba(242, 243, 247, 1);
          padding-left: 60px;

          display: flex;
          align-items: center;
          justify-content: flex-start;

          &-order {
            position: absolute;
            left: 20px;
            font-size: 16px;
            font-weight: 600;
            color: rgba(174, 186, 198, 1);
          }

          &:hover {
            opacity: 0.6;
          }

          &.active {
            opacity: 0.2;
          }
          &-content {
            ::v-deep .phtContent {
              .pht_single {
                text-align: start;
                margin-bottom: 0 !important;
              }
            }
          }
        }
      }
    }
  }
}
</style>
